/**
 * Shared grid math for SquareGrid and consumers (purchase page, skeletons, etc.).
 */

/**
 * Compute grid dimensions (cols × rows) for a given total number of squares.
 */
export function getGridDimensions(totalSquares) {
  const cols = Math.ceil(Math.sqrt(totalSquares));
  const rows = Math.ceil(totalSquares / cols);
  return { cols, rows };
}

/**
 * Convert a 1-based square number to a human-friendly coordinate.
 * Column → letter (A, B, …), Row → 1-based number.
 * E.g. square 42 in a 10-col grid → "E5".
 */
export function squareToCoord(num, totalSquares = 100) {
  const { cols } = getGridDimensions(totalSquares);
  const row = Math.floor((num - 1) / cols);
  const col = (num - 1) % cols;
  return `${String.fromCharCode(65 + col)}${row + 1}`;
}
